import { styled, Typography } from '@mui/material'

export const Heading = styled(Typography)(({ theme }) => ({
    color: theme.palette.text.primary,
    fontSize: theme.typography.h2.fontSize,
    fontWeight: 600,
    fontFamily: theme.typography.fontFamily,
    marginBlock: '0.5rem',
}))